if (!customElements.get('bonbons-grid')) {
  class BonbonsGrid extends HTMLElement {
    constructor() {
      super();

      this.gridEl = this.querySelectorAll('[data-grid]');
      this.dietaryPreferencesFilter = this.querySelector(
        '[data-filter-dietary-preferences]',
      );
      this.isotopeGrid = [];

      this.initIsotope();
      this.handleFiltering();
    }

    initIsotope() {
      this.gridEl.forEach((grid) => {
        const instance = new Isotope(grid, {
          itemSelector: '.bonbons__grid-item',
          layoutMode: 'fitRows',
        });

        this.isotopeGrid.push(instance);
      });

      this.isotopeGrid.forEach((iso) => {
        iso.on('arrangeComplete', function (filteredItems) {
          const container = iso.element;
          const visibleEls = filteredItems.map((item) => item.element);
          const allEls = Array.from(container.children).filter((el) =>
            el.matches(iso.options.itemSelector),
          );
          const hiddenEls = allEls.filter((el) => !visibleEls.includes(el));

          visibleEls.forEach((el) => container.appendChild(el));
          hiddenEls.forEach((el) => container.appendChild(el));
        });
      });
    }

    handleFiltering() {
      this.dietaryPreferencesFilter?.addEventListener('change', (e) => {
        const checkedCheckboxes =
          this.dietaryPreferencesFilter.getCheckedCheckboxes();
        const activeFilters = checkedCheckboxes.map(
          (checkbox) => checkbox.dataset.value,
        );

        this.isotopeGrid.forEach((instance) => {
          instance.arrange({
            filter: function (bonbon) {
              const bonbonDietaryPreferences =
                bonbon.dataset.dietaryPreferences;
              const matchesFilters = activeFilters.every((filter) =>
                bonbonDietaryPreferences.includes(filter),
              );

              return matchesFilters;
            },
          });
        });
      });
    }
  }

  customElements.define('bonbons-grid', BonbonsGrid);
}
